export const surfaces: string[] = [
  'Overall',
  'Hard',
  'Grass',
  'Clay',
];



// WEBPACK FOOTER //
// ./src/app/constants/surfaces.ts